import PropTypes from 'prop-types'

export const FormButton = ({
  type = 'button',
  variant = 'primary',
  loading = false,
  disabled = false,
  onClick,
  children,
  fullWidth = true,
  className = '',
}) => {
  const getButtonClasses = () => {
    const base =
      'font-medium rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2 focus:ring-offset-gray-900'

    const widthClass = fullWidth ? 'w-full' : ''

    let variantClass = ''
    switch (variant) {
      case 'primary':
        variantClass = 'py-3 px-4 bg-white hover:bg-gray-100 text-black'
        break
      case 'secondary':
        variantClass =
          'py-3 px-4 bg-dark-tertiary hover:bg-dark-primary text-white border border-dark-border'
        break
      case 'danger':
        variantClass = 'py-3 px-4 bg-red-600 hover:bg-red-700 text-white'
        break
      default:
        variantClass = 'py-3 px-4 bg-white hover:bg-gray-100 text-black'
    }

    return `${widthClass} ${variantClass} ${base} ${className}`.trim()
  }

  return (
    <button
      type={type}
      disabled={disabled || loading}
      onClick={onClick}
      className={getButtonClasses()}
    >
      {loading ? 'Loading...' : children}
    </button>
  )
}

FormButton.propTypes = {
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  variant: PropTypes.oneOf(['primary', 'secondary', 'danger']),
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  fullWidth: PropTypes.bool,
  className: PropTypes.string,
}

export default FormButton
